import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { compose } from 'redux';
import {
  Segment,
  Loader,
  Container,
  Sidebar,
  Icon,
  Header,
  Dimmer,
  Di,
  ConfirmModal,
} from 'nallian-shared-ui/lib/components';
import { history } from 'nallian-shared-ui/lib/config/history';
import { hasRight, doesntHaveRight } from 'nallian-shared-ui/lib/lib/routesHelper';
import { FetchHandlerModule, ActionsMenu } from 'nallian-shared-ui/lib/modules';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { GetOrganisationId, GetRights } from 'nallian-shared-ui/lib/selectors';
import vehicleService from '../../vehicles/services/vehicleService';
import deleteVehicleService from '../../vehicles/services/deleteVehicleService';
import VehicleDetailsList from '../../vehicles/components/VehicleDetailsList';
// import VehicleAccessLogsOverview from './VehicleAccessLogsOverview';
import NewAccessRightModal from '../../accessRights/components/NewAccessRightModal';
import EditAccessRightModal from '../../accessRights/components/EditAccessRightModal';
import RequestAccessRightModal from '../../requests/components/RequestAccessRightModal';
import AllVehicleAccessRightsOverview from './AllVehicleAccessRightsOverview';
import OnPremiseVehicleAccessRightsOverview from './OnPremiseVehicleAccessRightsOverview';
// import OffPremiseVehicleAccessRightsOverview from './OffPremiseVehicleAccessRightsOverview';
import EditVehicleModal from '../../vehicles/components/EditVehicleModal';

export const VEHICLE_SIDEBAR_ACTIONS = {
  EDIT_ACCESS_RIGHT: 'edit-access-right',
  EDIT_VEHICLE: 'edit-vehicle',
  NEW_ACCESS_RIGHT: 'new-access-right',
  REQUEST_ACCESS_RIGHT: 'request-access-right',
};

const FlexedDiv = styled.div`
  display: flex;
  flex-flow: row;
  align-items: baseline;
`;

const VehicleActionsMenu = styled(props => <ActionsMenu {...props} />)`
  & > .icon {
    font-size: 1.5rem;
    line-height: 1;
  }
`;

// const AddButton = styled(props => (
//   <Button
//     name="add"
//     floated="right"
//     size="large"
//     iconbutton
//     margin="calc(2rem - .14285714em) 0 1rem"
//     {...props}
//   />
// ))`
//   position: relative;
//   z-index: 2;
// `;

class VehicleSidebar extends PureComponent {
  componentDidUpdate(prevProps) {
    const { vehicleId, dispatchVehicleGet } = this.props;
    if (vehicleId && vehicleId !== prevProps.vehicleId) {
      dispatchVehicleGet(vehicleId);
    }
  }

  componentWillMount() {
    const { vehicleId } = this.props;
    if (vehicleId) {
      this.props.dispatchVehicleGet(vehicleId);
    }
  }

  handleDeleteVehicle = licensePlate => {
    this.props.dispatchDeleteVehicleDelete(licensePlate);
    history.push(`${this.props.baseUrl}${document.location.search}`);
  };

  render() {
    const {
      vehicleId,
      vehicleFetch,
      baseUrl,
      sidebarAction,
      sidebarActionId,
      sidebarUrl,
      noAccessRightEdit,
      organisationId,
      t,
      rights,
    } = this.props;

    const canView =
      hasRight(rights, 'organisations/read/access-rights') &&
      doesntHaveRight(rights, 'access-rights/read');

    return (
      <>
        <EditVehicleModal
          vehicleId={
            ((sidebarAction && sidebarAction === VEHICLE_SIDEBAR_ACTIONS.EDIT_VEHICLE) ||
              undefined) &&
            sidebarActionId
          }
          returnRoute={`${sidebarUrl}${document.location.search}`}
        />
        <NewAccessRightModal
          open={!!sidebarAction && sidebarAction === VEHICLE_SIDEBAR_ACTIONS.NEW_ACCESS_RIGHT}
          vehicleId={vehicleId}
          returnRoute={`${sidebarUrl}${document.location.search}`}
        />
        <RequestAccessRightModal
          open={!!sidebarAction && sidebarAction === VEHICLE_SIDEBAR_ACTIONS.REQUEST_ACCESS_RIGHT}
          vehicleId={vehicleId}
          returnRoute={`${sidebarUrl}${document.location.search}`}
        />
        <EditAccessRightModal
          accessRightId={
            ((sidebarAction && sidebarAction === VEHICLE_SIDEBAR_ACTIONS.EDIT_ACCESS_RIGHT) ||
              undefined) &&
            sidebarActionId
          }
          returnRoute={`${sidebarUrl}${document.location.search}`}
        />
        <Sidebar
          direction="right"
          visible={!!vehicleId}
          as={Segment}
          animation="overlay"
          width="wide"
        >
          <FlexedDiv>
            <Icon
              name="close"
              size="large"
              onClick={() => history.push(baseUrl + document.location.search)}
              iconbutton
            />
            <Header textAlign="center" size="large" margin="0 0 1rem" growing>
              {get(vehicleFetch, 'value.licensePlate', '...')}
            </Header>
            {vehicleFetch.value && organisationId === vehicleFetch.value.createdById && (
              <VehicleActionsMenu size="large">
                <ActionsMenu.Action
                  title={t('editVehicle')}
                  icon="pencil"
                  onClick={() =>
                    history.push(
                      `${sidebarUrl}/${VEHICLE_SIDEBAR_ACTIONS.EDIT_VEHICLE}/${vehicleId}${document.location.search}`,
                      {
                        goBack: true,
                      }
                    )
                  }
                  content={t('edit')}
                />
                <ConfirmModal
                  header={t('deleteVehicleConfirmation')}
                  cancelContent={t('cancel')}
                  confirmContent={t('delete')}
                  confirmIcon="trash"
                  confirmColor="red"
                  onConfirm={() => this.handleDeleteVehicle(vehicleId)}
                  trigger={
                    <ActionsMenu.Action
                      title={t('deleteVehicle')}
                      icon="trash"
                      content={t('delete')}
                    />
                  }
                />
              </VehicleActionsMenu>
            )}
          </FlexedDiv>

          <Container>
            <FetchHandlerModule fetches={[vehicleFetch]}>
              <Di.Dimmable>
                <Dimmer active={vehicleFetch.pending} inverted>
                  <Loader />
                </Dimmer>
                <VehicleDetailsList vehicle={vehicleFetch.value} />
              </Di.Dimmable>
            </FetchHandlerModule>
          </Container>
          <HasRight right="access-rights/read">
            <Header as="h3">{t('accessRights_plural')}</Header>
            <AllVehicleAccessRightsOverview
              noEdit={noAccessRightEdit}
              noAdd={!vehicleFetch.value || organisationId !== vehicleFetch.value.createdById}
              vehicleId={vehicleId}
              baseUrl={sidebarUrl}
            />
          </HasRight>
          {canView && (
            <Fragment>
              <Header as="h3">{t('accessRights_plural')}</Header>
              <OnPremiseVehicleAccessRightsOverview
                noEdit={noAccessRightEdit}
                vehicleId={vehicleId}
                baseUrl={sidebarUrl}
              />
            </Fragment>
          )}
        </Sidebar>
      </>
    );
  }
}

VehicleSidebar.propTypes = {
  t: PropTypes.func.isRequired,
  vehicleFetch: PropTypes.object.isRequired,
  dispatchVehicleGet: PropTypes.func.isRequired,
  vehicleId: PropTypes.string,
  baseUrl: PropTypes.string.isRequired,
  sidebarUrl: PropTypes.string.isRequired,
  dispatchDeleteVehicleDelete: PropTypes.func.isRequired,
  organisationId: PropTypes.string.isRequired,
  urlSearch: PropTypes.string,
  sidebarAction: PropTypes.string,
  sidebarActionId: PropTypes.string,
  noAccessRightEdit: PropTypes.bool,
  rights: PropTypes.array,
};

VehicleSidebar.defaultProps = {
  urlSearch: '',
  vehicleId: undefined,
  sidebarAction: undefined,
  sidebarActionId: undefined,
  noAccessRightEdit: true,
  rights: [],
};

const mapStateToProps = state => ({
  organisationId: GetOrganisationId(state),
  rights: GetRights(state),
});

export default compose(
  connect(mapStateToProps),
  withTranslation(),
  vehicleService,
  deleteVehicleService
)(VehicleSidebar);
